import { REQUEST_URL } from "../constants";

export default function requestJson(key) {
  return {
    type: REQUEST_URL,
    key,
  };
}
